import React                            from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import PjaxWrapper                      from "../utils/PjaxWrapper";
import Pagination                       from '../components/Pagination';
import ReloadHelper from '../utils/ReloadHelper';

function run(
    hook,
    currentPage,
    maxPage,
    targetHook,
    targetUri
) {
	const container = document.getElementById(hook);

    const goToFn = (page) => {
        const uri = targetUri.replace(new RegExp(targetHook, 'g'), page);
        ReloadHelper.reload(uri);
    };

	if (container) {
		render(
            <Pagination
                containerID = {hook}
                currentPage = {currentPage}
                maxPage     = {maxPage}
                goToFn      = {goToFn}
            />, 
            container
        );

		PjaxWrapper.addUnloadFunc(() => {
			unmountComponentAtNode(container);
		});
	}
}


export {run};